<template>
  <div class="app-search dropdown d-none d-lg-block">
    <form @submit.prevent="globalSearch">
      <div class="app-search-content input-group">
        <base-input
          v-model="keyword"
          type="text"
          :placeholder="$t('components.global_search.search')"
          id="top-search"
          item-class="custom-input-group-append border border-end-0 rounded-start"
        />
        <span class="mdi mdi-magnify search-icon"></span>
        <base-button item-class="btn-primary border-0" :disabled="isDisabled === true">
          {{
            loading === true ? $t('components.global_search.searching') + '...' : $t('components.global_search.search')
          }}
        </base-button>
      </div>
    </form>
    <dropdown item-class="dropdown-lg" :show="showSearch" :right="false">
      <!-- item-->
      <div class="dropdown-item noti-title">
        <p class="mb-0">
          {{ $t('components.global_search.total_result') }}:
          <strong class="text-danger">{{ results.total }}</strong>
        </p>
      </div>
      <div class="slimScrollDiv">
        <div class="slimscroll">
          <template v-for="(result, key) in results.results" :key="key">
            <div v-if="indexes[key]" class="dropdown-header noti-title p-0">
              <p class="text-overflow text-uppercase fw-bold mb-0 bg-primary-lighten px-2 py-1">
                {{ indexes[key].title }} ({{ result.length }})
              </p>
              <div class="notification-list">
                <template v-for="item in result" :key="item.id">
                  <router-link
                    v-if="indexes[key]"
                    :to="{
                      name: indexes[key].route,
                      params: { id: item.id }
                    }"
                    class="dropdown-item notify-item text-decoration-none px-0 py-1"
                  >
                  <div class="media px-2">
                    <div class="media-body">
                      <p class="m-0 font-14">
                        {{ item.id }} -
                        {{ item[indexes[key].field] }}
                        <template v-if="item.receivable_open_amount">
                          -
                          <strong>{{ money.ofMinor(item.receivable_open_amount).getFormattedAmount() }}</strong>
                        </template>
                      </p>
                    </div>
                  </div>
                </router-link>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </dropdown>
  </div>
</template>
<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

import { useSearchStore } from '@/stores/admin/search.js'
import i18n from '@/i18n/i18n.js'
import money from '@/utilities/money.js'

import BaseButton from '@/components/BaseButton.vue'
import BaseInput from '@/components/BaseInput.vue'
import Dropdown from '@/components/Dropdown.vue'

const { t } = i18n.global

// #region - Pinia store
const searchStore = useSearchStore()
// endregion

// #region - References
const keyword = ref('')
const showSearchResults = ref(false)
const disabled = ref(false)
const loading = ref(false)
const indexes = {
  farmers: {
    title: t('components.global_search.farmer_index_title'),
    route: 'admin.farmers.show',
    field: 'fullname'
  },
  orders: {
    title: t('components.global_search.order_index_title'),
    route: 'admin.orders.show',
    field: 'farmer'
  },
  applications: {
    title: t('components.global_search.application_index_title'),
    route: 'admin.applications.show',
    field: 'farmer'
  },
  retailers: {
    title: t('components.global_search.retailer_index_title'),
    route: 'admin.retailers.show',
    field: 'name'
  }
}
// endregion

// #region - computed properties
const results = computed(() => searchStore.results)

const showSearch = computed(() => (showSearchResults.value ? 'show' : ''))

const isDisabled = computed(() => {
  if (keyword.value) {
    return disabled.value
  }
  return true
})
// endregion

// #region - Method definitions
const globalSearch = async () => {
  if (keyword.value) {
    loading.value = true
    disabled.value = true
    try {
      await searchStore.search({ keyword: keyword.value })
      showSearchResults.value = true
    } catch (error) {
      disabled.value = true
      showSearchResults.value = false
      throw new Error('Search Error:', error)
    } finally {
      loading.value = false
      disabled.value = false
    }
  }
}
const close = e => {
  if (!e.target.closest('.app-search')) {
    showSearchResults.value = false
  }
}
// endregion

onMounted(() => window.addEventListener('click', close))
onBeforeUnmount(() => window.removeEventListener('click', close))
</script>

<style scoped>
.app-search-content {
  flex-wrap: nowrap;
}
</style>
